import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SettingsIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { getInboxChannelsTableUrl } from '../../urls/inboxSettingsUrls';
import { clickedInboxSettings } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { trackEventBeforeUnload } from '../../usage-tracking/clients/usageTracker';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InboxSettingsFooterSection = () => {
  const inboxId = useSelector(getCurrentInboxId);
  return /*#__PURE__*/_jsxs(Flex, {
    borderBlockStartColor: "border-core-subtle",
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: "100",
    display: "inline-flex",
    paddingBlock: "300",
    paddingInlineStart: "400",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: SettingsIcon,
      marginInlineStart: "100",
      padding: "0",
      size: "300"
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "inbox-sidebar-settings-button",
      use: "link",
      marginInlineStart: "200",
      href: getInboxChannelsTableUrl({
        inboxId
      }),
      onClick: () => trackEventBeforeUnload(clickedInboxSettings),
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-default",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.unified-inbox.settingsLink"
        })
      })
    })]
  });
};
InboxSettingsFooterSection.displayName = 'InboxSettingsFooterSection';
export default InboxSettingsFooterSection;